import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.css';
export var VisibilityWrapper = /*#__PURE__*/function (_React$Component) {
  function VisibilityWrapper() {
    var _this;
    _classCallCheck(this, VisibilityWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VisibilityWrapper, [].concat(args));
    _defineProperty(_this, "state", {
      mounted: _this.props.visible
    });
    return _this;
  }
  _inherits(VisibilityWrapper, _React$Component);
  return _createClass(VisibilityWrapper, [{
    key: "render",
    value: function render() {
      if (!this.state.mounted) {
        return null;
      }
      var _this$props = this.props,
        children = _this$props.children,
        visible = _this$props.visible;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var childrenProps = children.props;
      var childStyles = clsx(childrenProps.styles, !visible && styles['hidden']);
      return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, childrenProps), {}, {
        styles: childStyles
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.visible) {
        return {
          mounted: true
        };
      }
      return null;
    }
  }]);
}(React.Component);